<template>
  <div class="dropdown is-hoverable">
    <div class="dropdown-trigger">
      <a class="tag">{{ title }}</a>
    </div>
    <div class="dropdown-menu">
      <div class="dropdown-content">
        <div class="dropdown-item">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>



// WEBPACK FOOTER //
// Dropdown.vue?a5b78568